import script from "./parameter-all-drawer.vue?vue&type=script&lang=ts&setup=true"
export * from "./parameter-all-drawer.vue?vue&type=script&lang=ts&setup=true"

import "./parameter-all-drawer.vue?vue&type=style&index=0&id=77cb5f95&lang=scss&scoped=true"

import exportComponent from "D:\\web\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77cb5f95"]])

export default __exports__